import React, { ReactElement } from 'react';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { closeAllPopups, closePopup, openPopup } from "../../store/slices/popupSlice";
import { v4 } from "uuid";
import UnsavedChangesWarning from '../../popups/UnsavedChangesWarning';

type ConfigT = {
    header?: ReactElement,
    body: ReactElement,
    footer?: ReactElement
    className?: string;
    key?: string;
};

/**
 * Returns few functions for manage popup windows
 * */

const usePopup = () => {
    const dispatch = useAppDispatch();

    // open new popup window
    const createPopup = (config: ConfigT) => {
        const popupID = v4();
        
        dispatch(openPopup({
            id: popupID,
            ...config
        }));
    };

    // close popup window
    const removePopup = () => {
        dispatch(closePopup());
    };

    // close all popup windows at the same time
    const removeAllPopups = () => {
        dispatch(closeAllPopups())
    };

    return { createPopup, removePopup, removeAllPopups };
};

export default usePopup;